import React from "react";

interface Props {
  count: number;
  // Singular noun for the record type, e.g. "paid order" or "payout".
  // Pluralized with a trailing "s".
  noun: string;
}

// Informational (not a warning) note for records that have no usable date.
// Render this ONLY on the All Time view: there, records with no date ARE
// included in the totals (no lower bound to exclude them), so this just makes
// that transparent — money is never silently dropped. On a bounded window the
// caller shows nothing, because a dateless record simply can't be placed in
// time and is correctly absent. Renders nothing when count is 0.
export default function UndatedNote({ count, noun }: Props) {
  if (count <= 0) return null;
  const isOne = count === 1;
  return (
    <div className="adm-range-note" role="status">
      {count} {noun}
      {isOne ? "" : "s"} {isOne ? "has" : "have"} no date on record —
      {isOne ? " it’s" : " they’re"} included in these all-time totals.
    </div>
  );
}
